import { optimizeTracking } from '../../src/util/tracking'

window.addEventListener('load', () => optimizeTracking('optimize.footer'))
